import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

// export const getLlmMapperDataFromPostgres = async (data) => {
//   try {
//     const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
//     return await axios.get(`${BASEURL}/llm-mapper/get-llm-mapping`, {
//       headers: { Authorization: `Bearer ${parseToken}` },
//       params: { workflow_id: data.workflow_id, node_id: data.node_id },
//     });
//   } catch (error) {
//     if (error.response.status === 401) {
//       await logoutApi();
//     }
//     throw error;
//   }
// };

// export const saveLlmMapperDataFromPostgres = async (data) => {
//   try {
//     const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
//     return await axios.post(`${BASEURL}/llm-mapper/llm-workflow-data`, data, {
//       headers: { Authorization: `Bearer ${parseToken}` },
//     });
//   } catch (error) {
//     if (error.response.status === 401) {
//       await logoutApi();
//     }
//     throw error;
//   }
// };

export const fetchPEInsightsMappings = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/llm-mapper/generate-peinsight-mappings`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getQualityMetricValues = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/llm-mapper/get-quality-metric-values`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const fetchPEDataReport = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/llm-mapper/generate-private-equity-quality-report`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
